import '../style/components/EmptyState.css'

type EmptyStateProps = {
  icon?: string
  title?: string
  description?: string
  tags?: string[]
  action?: { label: string; onClick: () => void }
}

function EmptyState({
  icon = '🗒️',
  title = 'There is nothing here yet',
  description = 'Site visit recaps will appear once you add them. Check back soon to review and share updates.',
  tags = ['No site visits captured', 'AI ready to help'],
  action,
}: EmptyStateProps) {
  return (
    <div className="empty-state">
      <div className="empty-icon">{icon}</div>
      <h2>{title}</h2>
      <p>{description}</p>
      {action && (
        <button type="button" className="empty-action" onClick={action.onClick}>
          {action.label}
        </button>
      )}
      {tags.length > 0 && (
        <div className="empty-tags">
          {tags.map((tag) => (
            <span key={tag} className="pill">
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default EmptyState
